import * as Mutation from './mutation-types'
import Cargo from '@/api/tradingPlatform/cargo';

export default {
  getReport ({ commit }, {table, reportId, filter, clist = []}) {
    console.log(commit);
    console.log("getCargoReport" + reportId);
    Cargo.reportById(table, reportId, filter, clist).then(response => {
      console.log("response getCargoReport" + reportId);
      console.log(response);
      // commit(Mutation.SET_HOLIDAYS_CLIST, response.data["body"]["data"])
      // commit(Mutation.SET_HOLIDAYS_REPORT_DATA, response.data["body"]["data"])
      return commit(Mutation.ADD_REPORT, {body: response.data["body"], reportId: reportId})
    });
  },
  /* createEvent ({ commit }, event) {
    return commit(Mutation.CREATE_EVENT, event)
  },
  updateEvent ({ commit }, updatedEvent) {
    return commit(Mutation.UPDATE_EVENT, updatedEvent)
  },
  deleteEvent ({ commit }, eventId) {
    return commit(Mutation.DELETE_EVENT, eventId)
  },
  setweekendsVisible ({ commit }, enabled) {
    return commit(Mutation.SET_WEEKENDS_ENABLED, enabled)
  },
  setRef ({ commit }, event) {
    return commit(Mutation.CREATE_EVENT, event)
  },
  getCount ({ commit }) {
    return commit(Mutation.COUNT_EVENT)
  }, */
}
